/**
 * created by wang lei
 下标 页面
 *
 */
import React, {Component} from 'react';
import subscript from './subscript.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";
import {toolWidth} from "../../twoLinesEditorToolsSpace";

export default class SubscriptTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let subscript = this.props.editor.queryCommandState("subscript");
        this.setState({btnChecked: subscript === 1});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let subscript = this.props.editor.queryCommandState("subscript");
        this.setState({btnChecked: subscript === 1});
    }
    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'subscript' );
                this.setState({btnChecked: !this.state.btnChecked});
            }}>
                <img className={"editor-subscript-tool-btn"} style={style} width={toolWidth - 2}  src={subscript}/>
               <style>{`
                .editor-subscript-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-subscript-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-subscript-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        )
    }

}